export function scrollToOffer() {
  const element = document.getElementById('oferta')
  if (element) {
    const y = element.getBoundingClientRect().top + window.scrollY - 60 // Offset for sticky bar
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}
